export default function accordionEvent() {
	const accordionTitle = jQuery('.accordion__title');

	if (!accordionTitle) return;

	jQuery(accordionTitle).on('click', function () {
		jQuery(this).toggleClass('active');
		jQuery(this).next('.accordion__content').slideToggle();
	});
}